import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { desktopNavLinks } from '../../../constants';
import { styles } from '../index.styles';
import MobileNav from './MobileNav';

const Navbar = () => {
  /** @type {import('../../typings').IStateReducerState}*/
  const { isMobile, width } = useSelector((state) => state.appReducer);
  const history = useHistory();

  const [menuState, setMenuState] = useState(
   /** @type {import('../../typings').IHeaderState} */({
      anchorEl: null,
      openSub1: false,
      openSub2: false,
      ticker: '',
      symbol: '',
      date: '',
      hover: false,
      anchorElHover: null,
      anchorElStockMenu: null,
      anchorElOpenInterest: null,
      anchorMobile: null,
      anchorWatchlist: null,
    }))
  const isDesktop = width > 850 ? true : false

  const keyPress = (e) => {
    if (e.keyCode === 13) {
      localStorage.setItem('SYMBOL', menuState.ticker);
      history.push(`/stocks/${menuState.ticker}`);
      setMenuState({ ...menuState, ticker: '' });
    }
  };

  const buttonPress = () => {
    localStorage.setItem('SYMBOL', menuState.ticker);
    history.push(`/stocks/${menuState.ticker}`);
    setMenuState({ ...menuState, ticker: '' });
  };

  return (
    <div>
      <div
        style={isMobile ? styles.upHeaderMobile : styles.upHeader}
      >
        <div style={styles.upHeaderItem}>
          {isMobile && (
            <a
              href='https://optionsgeek.com/welcome-home-page/'>
              <img
                src='/OptionsGeekLogoFinalHeader.png'
                alt='logo'
                style={
                  isMobile ? styles.logoImgMobile : styles.logoImg
                } />
            </a>
          )}
          {isDesktop && (
            <div
              style={{
                width: '75%',
                display: 'flex',
                paddingTop: '5px',
              }}>
              <a
                href='https://optionsgeek.com/welcome-home-page/'>
                <img
                  src='/OptionsGeekLogoFinalHeader.png'
                  alt='logo'
                  style={
                    isMobile ? styles.logoImgMobile : styles.logoImg
                  } />
              </a>
              <input
                name='ticker'
                style={styles.tickerInput}
                value={menuState.ticker}
                placeholder='Enter Ticker'
                onChange={(e) => setMenuState({ ...menuState, ticker: e.target.value })}
                onKeyDown={(event) => keyPress(event)}
              />
              <span
                style={{
                  position: 'relative',
                  whiteSpace: 'nowrap',
                  fontSize: 0,
                }}>
                <button
                  style={styles.Gobutton}
                  onClick={(event) => buttonPress(event)}>
                  GO
                </button>
              </span>
            </div>
          )}

          {isMobile && <MobileNav menuState={menuState} setMenuState={setMenuState} />}

          {isDesktop &&
            <div style={{ display: 'flex' }}>
              {desktopNavLinks.map(({ title, slug, bgColor }, i) => (
                <div key={i} style={{ marginLeft: i > 0 ? '20px' : '0px' }}>
                  <a
                    href={slug}
                    style={{
                      ...styles.topbtns,
                      background: bgColor,
                      margin: '0px',
                    }}>
                    {title}
                  </a>
                </div>
              ))}
            </div>}
        </div>
      </div>
    </div>
  )
}
export default Navbar;


// WEBPACK FOOTER //
// ./src/components/Header/Navbar/index.jsx